/**
 * Created by rickborst on 24/04/2017.
 */

import {
    convertForPrepareRail,
    convertFromPrepareRail,
    groupFilterGridRails
} from '../adapters/rails';
import {isValidResponse} from '../validators/assets';

/**
 * Prepared any given rails by requesting their contents using multirequest.
 *
 * @param {Array} [rails] - Rails.
 * @returns {Promise} Prepare rails promise.
 */
export function prepareRails (rails = []) {

    return Promise.resolve(groupFilterGridRails.call(this, rails));
}

/**
 * Loads assets of any given rail by requesting their contents.
 *
 * @param {{rail: Object, amount: number, page: number}} config - Rail config.
 * @returns {Promise} Prepare rail promise.
 */
export function loadRailAssets (config) {
    const url = this._baseUrl + this._endPoints.assetList;

    let data = convertForPrepareRail.call(this, config);

    return this.read(
        {
            url: url,
            data: data
        })
        .then((response) => {

            if (!isValidResponse(response)) {

                return Promise.reject(response);
            }

            return convertFromPrepareRail.call(this, response);
        });
}




// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/services/rails.js